<script setup lang="ts">
import { supabase } from '@/composables/supabaseClient'
import toastThrowError from '@/helpers/toastThrowError'
import uuidv7 from '@/helpers/uuidv7'
import { useDatabaseStore } from '@/stores/databaseStore'
import { ref } from 'vue'
import BaseButton from './BaseButton.vue'
import BaseInput from './BaseInput.vue'

const databaseStore = useDatabaseStore()

const newName = ref('')

async function saveNewSource() {
  if (newName.value === '') throw toastThrowError('New Estimate Type Name is Required')
  const result = await supabase
    .from('estimate_type')
    .insert({ id: uuidv7(), name: newName.value })
    .select()
    .single()
  if (result.error) throw toastThrowError('Unable to create estimate type', result.error)
  databaseStore.estimateTypes?.push(result.data)
  newName.value = ''
}
</script>

<template>
  <div class="flex h-full w-full flex-col gap-3 p-3">
    <span class="font-bold">Estimate Types</span>
    <div v-for="estimateStatus in databaseStore.estimateTypes" :key="estimateStatus.id">
      {{ estimateStatus.name }}
    </div>
    <BaseInput v-model="newName" class="w-full border p-1" placeholder="New Estimate Type..." />
    <BaseButton @click="saveNewSource()">Save</BaseButton>
  </div>
</template>
